import { LayoutGrid } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ROUTES } from "@/shared/model/routes";
import { RainbowButton } from "@/shared/ui/kit/rainbow-button";

export function NavCatalogButton() {
  const { t } = useTranslation();

  return (
    <RainbowButton size="sm" asChild className="gap-2">
      <Link to={ROUTES.PRODUCTS}>
        <LayoutGrid className="w-4 h-4" />
        <span className="hidden lg:inline">{t("nav.catalog")}</span>
      </Link>
    </RainbowButton>
  );
}
